import { Clock, Flame, ChefHat, Sparkles } from "lucide-react";

/**
 * Structured recipe card rendered inside YumoPot drawer.
 * Renders all 13 sections when present; hides sections that are empty.
 */
export default function RecipeCard({ recipe, source, provider }) {
  if (!recipe) return null;
  const r = recipe;
  const sourceLabel = source === "corpus" ? "From YUMO corpus" : "AI-generated · verify before cooking";
  return (
    <div className="w-full bg-card border border-border rounded-2xl p-4 space-y-3 shadow-sm" data-testid="recipe-card">
      <div className="flex items-center justify-between gap-2">
        <div className="overline">{r.cuisine || "Recipe"}</div>
        <span className={`text-[10px] px-2 py-0.5 rounded-full ${source === "corpus" ? "bg-primary/10 text-primary" : "bg-secondary text-muted-foreground"}`}>{sourceLabel}</span>
      </div>
      <h3 className="font-serif text-2xl tracking-tight leading-tight" data-testid="recipe-name">{r.name}</h3>
      {r.taste_profile && <p className="text-xs text-muted-foreground italic">{r.taste_profile}</p>}

      <div className="grid grid-cols-3 gap-2 text-center py-2 border-y border-border">
        <div><div className="overline text-[9px]">Prep</div><div className="text-sm font-medium">{r.prep_time || "—"}</div></div>
        <div><div className="overline text-[9px]">Cook</div><div className="text-sm font-medium">{r.cook_time || "—"}</div></div>
        <div><div className="overline text-[9px]">Level</div><div className="text-sm font-medium">{r.difficulty || "Easy"}</div></div>
      </div>

      {r.ingredients?.length > 0 && (
        <div>
          <div className="overline mb-1.5 flex items-center gap-1.5"><ChefHat className="w-3 h-3 text-primary" /> Ingredients</div>
          <ul className="text-xs space-y-1">{r.ingredients.map((it, i) => <li key={i} className="flex gap-1.5"><span className="text-primary">·</span>{it}</li>)}</ul>
        </div>
      )}
      {r.method?.length > 0 && (
        <div>
          <div className="overline mb-1.5 flex items-center gap-1.5"><Flame className="w-3 h-3 text-primary" /> Method</div>
          <ol className="text-xs space-y-1.5 list-decimal list-inside">{r.method.map((s, i) => <li key={i} className="leading-snug">{s}</li>)}</ol>
        </div>
      )}
      {r.tips && <div><div className="overline mb-1">Chef Tips</div><p className="text-xs leading-relaxed">{r.tips}</p></div>}
      {r.variations && <div><div className="overline mb-1">Variations</div><p className="text-xs leading-relaxed">{r.variations}</p></div>}
      {r.nutrition && <div><div className="overline mb-1">Nutrition</div><p className="text-xs leading-relaxed">{r.nutrition}</p></div>}
      {(r.meal_time || r.sides) && (
        <div className="flex flex-wrap gap-3 text-xs pt-1">
          {r.meal_time && <div><span className="overline text-[9px] mr-1">Meal</span>{r.meal_time}</div>}
          {r.sides && <div><span className="overline text-[9px] mr-1">Pair with</span>{r.sides}</div>}
        </div>
      )}
      {provider && <div className="text-[9px] uppercase tracking-widest text-muted-foreground pt-1">via {provider}</div>}
    </div>
  );
}
